<template>
  <div id="architecture"
       :class="{ 
          loading: !ready,
        }"
   >
    <Status
      ref="Status"
      :msg="loading ? 'Loading...' : ready ? 'ready.' : errorMsg"
    />
    <div 
      id="menuButton"
      :class="{ hidden: !menu }"
      @click="scrollTo()"
    >
      ← <a>menu</a>
    </div>
    <div id="main-room" class="room">
      <div class="walls">
        <div class='wall left-wall'>
          <section id="nav">
            <p id="tagline">{{ tagline.body }}</p>
            <nav>
              <ul>
                <li
                  id="projects-link" 
                  @click="scrollTo('projects')"
                ><a>Projects</a></li>
                <li
                  id="friends-link"
                  @click="scrollTo('collaborators')"
                ><a>Partners</a></li>
                <li 
                  v-if="journals.length > 0"
                  id="journal-link" 
                  @click="scrollTo('journal')"
                ><a>Journal</a></li>
                <li
                  id="about-link" 
                  @click="scrollTo('about')"
                ><a>About</a></li>
                <li
                  id="contact-link" 
                  @click="scrollTo('contact')"
                ><a>Contact</a></li>
                <li
                  id="impressum-link" 
                  @click="scrollTo('impressum')"
                ><a>Impressum</a></li>
              </ul>
            </nav>
          </section>
          <Door
            :door="door"
          />
        </div>
        <div class="wall front-wall">
          <ProjectsAndFriends 
            ref="ProjectsAndFriends"
            :projects="projects" 
            :collaborators="collaborators"
            @childClicked="handleExternalClick($event)"
          />
          <Journals 
            v-if="journals.length > 0"
            ref="Journals"
            :journals="journals" 
            @childClicked="handleExternalClick($event)"
          />
          <About 
            ref="About"
            :about="about" 
          />
          <Contact 
            ref="Contact"
            :body="contact.body"
            :impressum="contact.Impressum"
            :photoSrc="contact.photoSrc"
            :credit="contact.credit"
            @impressum="movie1Visible = $event"
          />
          <section id="hall">
            <Poster 
              v-if="movie"
              :class="{ hidden: false }"
              :poster="movie"
            />
            <Poster 
              v-if="movie2"
              :poster="movie2"
              class="second"
            />
          </section>
        </div>
      </div>
      <div class="ground">
        <div class="window-shadow">
          <table>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
        </div>
        <div class="window-shadow door-shadow"></div>
        <Furniture 
          ref="Furniture"
        />
      </div>
    </div>
    <div id="back-room" class="room">
      <div class="walls">
        <div class="wall left-wall">
          <div class="window">
            <table>
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
            </table>
          </div>
          <a 
            class="door active"
            @click="scrollTo()"
          >
            <div class="knob"></div>  
          </a>
        </div>
        <div class="wall front-wall">
          <section class="rail back">
            <table>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </section>
        </div>
      </div>
      <div class="ground">
      </div>
    </div>
    <div id="outside" class="room">
      <div class="walls">
        <div class="wall left-wall">
          <div class="rail right">
              <table>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
            </table>
            <div class="hanging-pot">
              <div class="top side"></div>
              <div class="right side">
                <div class="flowers">
                  <div class="flower">
                    <div class="stem"></div>
                    <div class="leaves">
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                    </div>
                  </div>
                  <div class="flower">
                    <div class="stem"></div>
                    <div class="leaves">
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                    </div>
                  </div>
                  <div class="flower">
                    <div class="stem"></div>
                    <div class="leaves">
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                      <div class="leaf"></div>
                    </div>
                  </div>
                </div>
                <p id="inside-link" 
                   @click="scrollTo()">&#8634; <a>Go inside</a></p>
              </div>
              <div class="front side"></div>
            </div>
          </div>
        </div>
        <Torrey :v-if="torrey" :torrey="torrey" />
      </div>
    </div>
  </div>
</template>

<script>
import Status from '../components/Status'
import Door from '../components/Door'
import ProjectsAndFriends from '../components/ProjectsAndFriends'
import Journals from '../components/Journals'
import About from '../components/About'
import Contact from '../components/Contact'
import Furniture from '../components/Furniture'
import Poster from '../components/Poster'
import Torrey from '../components/Torrey'
import { EventBus } from '../EventBus'
    

export default {
  name: "Architecture",
  components: { 
    Status,
    Door,
    ProjectsAndFriends,
    Journals,
    About,
    Contact,
    Furniture,
    Poster,
    Torrey,
  },
  props: [
    'slug',
    'menu'
  ],
  data() {
    return {
      loading: true,
      ready: false,
      errorMsg: "architecture is broken :( contact karl <bonjour@moubarak.eu>",
      transitionDuration: 300,
      tagline: {},
      about: {},
      contact: {},
      door: '',
      movie: '',
      movie2: '',
      movie1Visible: true,
      torrey: '',
      projects: [],
      collaborators: [],
      journals: []
    }
  },
  created() {
    this.$http.get(this.$apiURL + '/tagline')
      .then((response) => { this.tagline = response.data })
      .catch((error) => { 
        this.ready = false
        console.log(error)
      }) 
    this.$http.get(this.$apiURL + '/door')
      .then((response) => { this.door = response.data })
      .catch((error) => { console.log(error) })     
    this.$http.get(this.$apiURL + '/movie')
      .then((response) => { this.movie = response.data })
      .catch((error) => { console.log(error) })
    this.$http.get(this.$apiURL + '/movie-2')
      .then((response) => { this.movie2 = response.data })
      .catch((error) => { console.log(error) })
    this.getMainData(this.$apiURL)
      .then(() => {
        this.loading = false
        this.ready = true
        if (this.slug) {
          setTimeout(() => {
            this.handleRouting(this.slug)
          }, this.transitionDuration)
        }
      })
      .catch((error) => {
        this.loading = false 
        this.ready = false
        console.log(error)
      })
    if (!EventBus.$root.mobile) {
      this.$http.get(this.$apiURL + '/torrey')
        .then((response) => { this.torrey = response.data })
        .catch((error) => { console.log(error) })  
    } else {
      this.torrey = null
    }
  },
  mounted() {
    this.$router.afterEach((to) => { 
      let slug = to.path.replace(this.$publicPath, '')
      this.handleRouting(slug)
    })
    document.addEventListener('keyup', (e) => { 
      if (e.keyCode === 27) this.$router.push(this.$publicPath + '/')
    })
  },
  methods: {
    async getMainData(url) {
      const [projects, collaborators, journals, about, contact] = await Promise.all([
        this.$http.get(url + '/projects'),
        this.$http.get(url + '/collaborators'),
        this.$http.get(url + '/film-journal-entries'),
        this.$http.get(url + '/about'),
        this.$http.get(url + '/contact'),
      ])
      this.projects = this.reorderProjects(projects)
      this.collaborators = this.reorderCollaborators(collaborators)
      this.journals = this.reorderJournals(journals)
      this.about = about.data
      this.contact = contact.data
      this.contact.photoSrc = url + this.contact.photo.formats.small.url
    },
    reorderProjects(projects) {
      let ongoingProjects = projects.data.filter(project => !project.EndDate)
      ongoingProjects.sort((a,b) => new Date(b.StartDate) - new Date( a.StartDate))
      let pastProjects = projects.data.filter(project => project.EndDate)
      let orderedPastProjects = pastProjects.sort((a, b) => (new Date(b.EndDate) - new Date(a.EndDate)))
      return projects = this.correctBodies(ongoingProjects.concat(orderedPastProjects)) 
    },
    reorderCollaborators(collaborators) {
      let orderedCollaborators = collaborators.data.sort((a ,b) => {
        var textA = a.name.toUpperCase();
        var textB = b.name.toUpperCase();
        return (textA < textB) ? -1 
              : (textA > textB) ? 1 
              : 0
      })
      return collaborators = orderedCollaborators
    },
    reorderJournals(journals) {
      let orderedJournals =  journals.data.sort((a, b) => (new Date(b.published_at) - new Date(a.published_at))) 
      return journals = this.correctBodies(orderedJournals) 
    },
    correctBodies(array) {
      for (let p = 0; p < array.length; p++) {
        if (array[p].body) {
          array[p].cleanBody = array[p].body.replace(/\]\(\/uploads\//g, `](${this.$apiURL}/uploads/`)
        }
      }
      return array
    },
    handleExternalClick(caller) {
      if (caller == 'journal') {
        this.closeProjectsAndFriends()
      } else if (this.journals.length > 0) {
        this.closeJournals()
      }
    },
    handleRouting(slug) {
      let sectionID = slug.split('/')[0]
      const sections = ['projects', 'collaborators', 'journal', 'about', 'contact', 'impressum']
      if (sections.indexOf(sectionID) > -1) {
        let sectionItemID = slug.split('/')[1]
        if (sectionItemID) {
          if (sectionID == 'projects') {
            const project = this.$refs.ProjectsAndFriends.$refs.projects.find(p => p.slug == sectionItemID)
            document.title = project.title
            this.$refs.ProjectsAndFriends.openProject(project)
          } else if (sectionID == 'collaborators') {
            const collaborator = this.$refs.ProjectsAndFriends.$refs.collaborators.find(c => c.slug == sectionItemID)
            document.title = collaborator.name + ' + Pia Chakraverti-Wuerthwein'
            this.$refs.ProjectsAndFriends.openCollaborator(collaborator)
          } else if (sectionID == 'journal') {
            const journal = this.$refs.Journals.$refs.journals.find(j => j.slug == sectionItemID)
            document.title = journal.title
            this.$refs.Journals.openJournal(journal)
          }
        }
        if ( sectionID == 'journals' 
          || sectionID == 'about'
          || sectionID == 'contact'
          || sectionID == 'impressum'
          || EventBus.$root.mobile
          ) {
          setTimeout(() => {
            this.scrollTo(sectionID)
          }, this.transitionDuration)
        }
      } else if (sectionID == '') {
        this.clearUI()
      } else {
        this.ready = false
        this.errorMsg = 'URL not found :('
        console.log('URL not found.')
      }
    },
    scrollTo(id) {
      if (!id) {
        this.$el.scroll({
          left: 0,
          behavior: 'smooth'
        })
      } else {
        let section = document.getElementById(id)
        if (id == 'impressum') {
          section = this.$refs.Contact.$el
          setTimeout(() => {
            this.$refs.Contact.toggleImpressum()
          }, this.transitionDuration)
        }
        this.$el.scroll({
          left: section.offsetLeft + 225,
          behavior: 'smooth'
        })
      }
    },
    clearUI() {
      document.title = 'Pia Chakraverti-Wuerthwein'
      this.closeProjectsAndFriends()
      if (this.journals.length > 0) {
        this.closeJournals()
      }
    },
    closeProjectsAndFriends() {
      this.$refs.ProjectsAndFriends.unfadeinEverything()
      setTimeout(() => {
        this.$refs.ProjectsAndFriends.unselectEverything()
        this.$refs.ProjectsAndFriends.unfadeEverything()
      this.$refs.ProjectsAndFriends.showEverything()
        this.$refs.ProjectsAndFriends.unHoverEverything()
        this.$refs.ProjectsAndFriends.expanded = false
        this.$refs.ProjectsAndFriends.projectsTitle = 'Projects'
        this.$refs.ProjectsAndFriends.collaboratorsTitle = 'Partners'
      }, this.transitionDuration)
    },
    closeJournals() {
      this.$refs.Journals.unfadeinEverything()
      setTimeout(() => {
        this.$refs.Journals.unselectEverything()
        this.$refs.Journals.unfadeEverything()
        this.$refs.Journals.unHoverEverything()
        this.$refs.Journals.expanded = false
      }, this.transitionDuration)
    }
  }
}
</script>

<style>

#architecture {
  /* position: relative; */
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow-y: hidden;
  overflow-x: scroll;
}
#architecture.loading #statusIndicator {
  position: absolute;
  text-align: center;
  opacity: 1;
  transition: all 1s ease;
}
#architecture.loading .room .walls .wall {
  opacity: 0;
  max-height: 0px;
  transition: all 0.5s ease;
}
#architecture.loading .room .ground {
  margin-bottom: -100px;
  transition: margin 0.5s ease;  
}
#architecture.loading .room .ground #furniture {
  margin-bottom: -300px;
  opacity: 0;
  transition: all 0.5s ease;
}
#menuButton {
  position: absolute;
  bottom: -5px;
  left: 0px;
  margin: 10px;
  z-index: 5;
  transition: bottom 0.2s ease;
}
#menuButton.hidden {
  bottom: -25px;
  transition: bottom 0.2s ease;
}
.room {
  height: calc(100vh + 150px);
  margin-top: -150px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.room .walls {
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  align-items: flex-end;
}
.room .walls .wall {
  padding-top: 70px;
  box-sizing: border-box;
  height: 100%;
  border-bottom: var(--thin-grey);
  opacity: 1;
  max-height: 1500px;
  transition: all 0.5s ease;
}
.room .walls .wall.left-wall {
  flex: 0 0 225px;
  width: 225px;
  transform-origin: top right;
  transform: skewY(-20deg);
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  border-bottom: var(--thin-grey);
}
.room .walls .wall.left-wall .window {
  margin: 20px;
  border: var(--ridge-grey);
}
.room .walls .wall.left-wall .door {
  width: 30%;
  max-height: 350px;
  height: 100%;
  margin-left: 20px;
  border: var(--ridge-grey);
  border-bottom: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 1;
}
.room .walls .wall.left-wall .door .knob {
  height: 1px;
  width: 10px;
  margin-right: 2px;
  margin-top: 70px;
  background: grey;
  border-left: var(--ridge-grey);
  border-top: var(--ridge-grey);
}
.room .walls .wall.front-wall {
  flex: 1 0 auto;
  display: flex;
  justify-content: flex-start;
}
.room .ground {
  box-sizing: border-box;
  flex-shrink: 0;
  height: 81.9px;
  width: calc(100% - 200px);
  transform-origin: bottom left;
  transform: skewX(-70deg);
  z-index: 0;
  display: flex;
  margin-bottom: 0px;
  transition: margin 0.3s ease; 
}
.room .ground .window-shadow {
  height: 50%;
  width: 100%;
  margin: 20px;
  background: var(--sunlight);
  filter: blur(3px);
  border-radius: 10px;
}



/* MAIN ROOM  */

#main-room .walls .wall {
  background: linear-gradient(0deg, var(--paler-yellow) 0%, var(--palest-yellow) 50%, var(--palest-yellow) 100%);
}
#main-room .walls .wall:after {
  content: '';
  width: 100%;
  height: 6px;
  position: absolute;
  bottom: 0;
  background: var(--paler-yellow);
  border-top: 2px ridge var(--paler-yellow);
  border-top: 2px solid rgb(0,0,0,0.1);
  border-bottom: 1px ridge var(--paler-yellow);
}
#main-room .walls .wall.left-wall .door {
  background: linear-gradient(to top, var(--dark-green), var(--dark-yellow-green));
  background: linear-gradient(to top, var(--dark-red), var(--lighter-red));
  border: var(--ridge-brown);
  border-bottom: 0;
}
#main-room .walls .wall.front-wall {
  position: relative;
  min-width: 2300px;
}
#main-room .walls .wall.front-wall:after {
  /* float:left; */
  border-left: 2px ridge var(--paler-yellow);
}
#main-room .ground {
  background: var(--ground);
  border-top: var(--thin-grey);
  align-items: center;
  justify-content: flex-end;
}
#main-room .ground .window-shadow {
  margin-right: 500px;
  width: 500px;
  height: 60%;
  background: none;
  filter: none;
}
#main-room .ground .window-shadow table {
  height: 100%;
  width: 100%;
}
#main-room .ground .window-shadow table td {
  flex: 1 0 auto;
  padding: 4px;
  background: var(--sunlight);
  filter: blur(3px);
}
#main-room .ground .window-shadow.door-shadow {
  width: 600px;
  height: 35%;
  margin-bottom: 0px;
  margin-right: 0px;
  background: var(--sunlight);
  filter: blur(4px);
}

#furniture {
  position: absolute;
  transform: scale(1.1);
  opacity: 1;
  left: 0px;
  top: 0px;
  transition: all 0.3s ease;
  z-index: 10;
}



/* HALL  */

#hall {
  width: 520px;
}




/* BACK ROOM  */

#back-room {
  z-index: 1;
  margin-left: -225.5px;
}
#back-room .walls .wall.front-wall {
  min-width: 100px;
}
#back-room .walls .wall.left-wall {
  overflow: hidden;
  border: var(--thin-grey);
  flex-direction: column;
}
#back-room .walls .wall.left-wall .window {
  height: 250px;
  box-shadow: 0 -50px 0 175px lightgrey;
  background: var(--glass);
  margin-bottom: auto;
  border: none;
}
#back-room .walls .wall.left-wall .door {
  background: var(--glass);
}
#back-room .walls .wall.left-wall .window table {
  height: 100%;
  width: 100%;
  border-collapse: collapse;
}
#back-room .walls .wall.left-wall .window table td {
  flex: 1 0 auto;
  border: var(--ridge-grey);
}



 /* WINDOW AND DOOR HACK  */

@media (min-height: 1501px) {
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px 0 0 720px lightgrey;
  }
}
@media (max-height: 1500px) {
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px -24vh 0 24vh lightgrey;
  }
}
@media (max-height: 1360px) {
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px -20vh 0 20vh lightgrey;
  }
}
@media (max-height: 1163px) {
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px -15vh 0 15vh lightgrey;
  }
}
@media (max-height: 1000px) {
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px -10vh 0 10vh lightgrey;
  }
}
@media (max-height: 875px) {
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px 5vh 0 100px lightgrey;
  }
}
@media (max-height: 763px) {
  #back-room .walls .wall.left-wall .window {
    height: 130px !important;
  }
  #back-room .walls .wall.left-wall .window table tr:last-of-type {
    display: none;
  }
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px 10px 0 100px lightgrey;
  }
}
@media (max-height: 650px) {
  #back-room .walls .wall.left-wall .window {
    height: 130px !important;
  }
}
@media (max-height: 670px) {
  #back-room .walls .wall.left-wall .window {
    height: 80px !important;
  }
  #back-room .walls .wall.left-wall .window table tr:nth-last-of-type(2) {
    display: none;
  }
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px 55px 0 100px lightgrey;
  }
}
@media (max-height: 575px) {
  #back-room .walls .wall.left-wall .window {
    height: 50px !important;
    box-shadow: 0 -100px 0 150px lightgrey;
  }
  #back-room .walls .wall.left-wall .door {
    box-shadow: 60px 70px 0 100px lightgrey;
  }
}
@media (max-height: 535px) {
  #back-room .walls .wall.left-wall .window {
    display: none;
  }
  #back-room .walls .wall.left-wall .door {
    box-shadow: 0 0 0 200px lightgrey;
  }
}




/* BALCONY  */

#back-room .walls .wall.front-wall {
  width: 180px;
}
#back-room .ground {
  width: 180px;
  background: lightgray;
  border-bottom: var(--ridge-grey);
  border-left: var(--thin-grey);
  border-top: var(--thin-grey);
  z-index: 1;
}
.rail {
  height: 130px;
  width: 100%;
}
.rail table {
  height: 100%;
  width: 100%;
  border-collapse: collapse;
}
.rail table tr:first-of-type {
  height: 25%;
}
.rail table td {
  border: var(--ridge-grey);
}
.rail.back {
  align-self: flex-end;
}
.rail.right {
  margin-bottom: 80px;
}
#outside {
  margin-left: -225.5px;
  z-index: 1;
}
.flowers {
}
.flowers .flower {
  height: 100%;
  width: 20px;
  margin-top: -40px;
  margin-left: 8px;
}
.flowers .flower .stem { 
  width: 100%;
  height: 100%;
  border-left: 2px ridge var(--pale-green);
  border-radius: 50%/60px;
}
.flowers .flower .leaves { 
  position: absolute;
  top: -40px;
  width: 10px;
  transform: rotate(10deg);
  display: flex;
  flex-wrap: wrap;
}
.flowers .flower .leaves .leaf { 
  width: 4px;
  height: 8px;
  margin-top: -4px;
  border-radius: 90% / 100%;
  border: 0.5px solid var(--leaf-border);
  background: var(--leaf);
  transform: rotate(-20deg);
}


.hanging-pot {
  position: absolute;
  bottom: 180px;
  right: 20px;
  width: 90px;
  height: 30px;
  box-sizing: content-box;
}
.hanging-pot .side {
  box-sizing: border-box;
  background: linear-gradient(to bottom, var(--pot-border), var(--pot));
  border: 0.5px solid var(--pot-border);
}
.hanging-pot .top {
	width: 100%;
  height: 10px;
  transform-origin: top right;
  transform: skewX(70deg);
  background: var(--soil);
  border: none;
}
.hanging-pot .front {
  height: 100%;
  width: 30px;
  transform: skewY(20deg) translateY(-35px);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
.hanging-pot .right {
  margin-left: 29px;
  width: 100%;
  height: 100%;
  border-bottom-right-radius: 6px;
}
.hanging-pot .right .flowers {
  position: absolute;
  bottom: 20px;
  display: flex;
}
.hanging-pot .right .flowers .flower {
  height: 50px;
  transform: rotate(10deg);
  animation: inthewind 4s ease-in-out infinite ;
}
@keyframes inthewind {
  0% {
    transform: rotate(3deg);
  }
  50% {
    transform: rotate(10deg) skewX(-10deg);
  }
  100% {
    transform: rotate(3deg);
  }
}
.hanging-pot .right .flowers .flower .stem {
}
.hanging-pot .right .flowers .flower .leaves {
  margin-top: 35px;
  margin-left: 0px;
  width: 12px;
}
.hanging-pot .right .flowers .flower .leaf:nth-child(odd) { 
  /* transform: rotate(3deg); */
}
.hanging-pot .right .flowers .flower .leaf:nth-child(1) { 
  transform: rotate(10deg);
  margin-left: 2px;
}
.hanging-pot .right .flowers .flower:nth-last-of-type(1) {
  transform: rotate(30deg);
}
.hanging-pot .right .flowers .flower:nth-last-of-type(1) .leaves {
  margin-top: 45px;
  margin-left: -3px;
}
.hanging-pot .right .flowers .flower:nth-last-of-type(2) .leaves {
  margin-top: 20px;
  margin-left: 0px;
}
#inside-link {
  width: 75px;
  font-size: 10pt;
  padding: 5px;
  margin-top: 2px;
  text-align: center;
  cursor: pointer;
  z-index: 20;
}

</style>


